
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"レイヤー 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Path 142","d":"M32.12 0H32A31.4 31.4 0 007.39 51L2.82 61.61a1.7 1.7 0 00.88 2.24 1.72 1.72 0 001 .13L21.47 61a30.31 30.31 0 0010.46 1.82A31.43 31.43 0 1032.12 0zM21.35 25.14h9.26a1.72 1.72 0 010 3.43h-9.26a1.72 1.72 0 010-3.43zm21.26 12H21.35a1.72 1.72 0 010-3.43h21.26a1.72 1.72 0 110 3.43z"}})])
          )
        }
      }
    